/* eslint-disable class-methods-use-this */
import { BaseObject, SpaceObjectType } from '@ootk/src/main';
export class LaunchSite extends BaseObject {
    lat;
    lon;
    alt;
    site; // Optional site name
    country; // Optional country name
    wikiUrl; // Optional Wikipedia URL
    constructor(info) {
        super(info);
        Object.keys(info).forEach((key) => {
            this[key] = info[key];
        });
        this.type = SpaceObjectType.LAUNCH_SITE;
    }
    isLandObject() {
        return true;
    }
    isStatic() {
        return true;
    }
}
